// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "", ""]);
// Exports
exports.locals = {
	"menuText": "#000",
	"menuActiveText": "#000",
	"subMenuActiveText": "#000",
	"menuBg": "#fff",
	"menuHover": "#fff",
	"subMenuBg": "#fff",
	"subMenuHover": "#fff",
	"sideBarWidth": "215px"
};
module.exports = exports;
